module.exports = __webpack_public_path__ + "static/media/solutions-workshop.0a3c7c34.jpg";